<template>
  <div class="resume__quote-content">
    <h2 class="resume__quote-subtitle">Detalle de cotización</h2>
    <!-- Desarrollos con más de una política de venta (p. ej. Valle Norte): el cliente elige el esquema -->
    <div class="radio__button-box" v-if="esquemas.length > 1">
      <radio-button-quote
        v-for="e in esquemas"
        :key="e.id"
        :class="disabled"
        @onUpdatePlan="updateEsquema"
        :activePlan="esquemaActivo"
        :content="'esquema_' + e.id"
        :value="e.id"
        interes="0"
        :text="e.texto"
      />
    </div>
    <div class="radio__button-box">
      <!-- Plazos dinámicos según el grupo de financiamiento del desarrollo (Política 2026) -->
      <radio-button-quote
        v-for="plazo in plazosDisponibles"
        :key="plazo"
        :class="disabled"
        @onUpdatePlan="updateActivePlan"
        :activePlan="activePlan"
        :content="'content_' + plazo"
        :value="String(plazo)"
        :interes="tasaParaPlazo(plazo)"
        :sin-interes="tasaParaPlazo(plazo) === 0"
        :text="plazo + ' meses'"
      />
    </div>
    <!-- Plan Constructor y Plan Construye tu Casa — solo para desarrollos autorizados en la política 2026 -->
    <div class="radio__button-box" v-if="mostrarPlanesEspeciales">
       <radio-button-quote
        :class="disabled"
        @onUpdatePlan="updateActivePlan"
        :activePlan="activePlan"
        content="content5"
        value="-1"
        interes="0"
        text="Plan constructor"
      />
      <radio-button-quote
        :class="disabled"
        @onUpdatePlan="updateActivePlan"
        :activePlan="activePlan"
        content="content6"
        value="-2"
        interes="0"
        text="Plan construye tu casa"
      />
    </div>
    <!---->
    <div class="btn_box">
      <a
        href=""
        :class="disabled"
        @click.prevent="_getFinancial()"
        class="btn btn__resume"
        v-if="planconstructor == 0"
        >{{ loaderFinancial == true ? "cotizando..." : "cotizar" }}</a
      >
    </div>
    <div class="line_horizontal" :class="{ hider: planconstructor != 0 }"></div>
    <loader-resume v-if="loaderFinancial" />
    <div class="content__resume" v-if="resumeBox">
      <div :class="{ hider: planconstructor != 0 }">
        <h2 class="content__resume-subtitle">Resumen</h2>
        <p>
           Precio total del terreno:
          <span>${{ formatValue(selected.value) }}</span>
        </p>
        <!-- <p>
          Precio menos el 20% de enganche:
          <span>${{ formatValue(financial.financedAmount) }}</span>
        </p> -->
        <p>
          Monto del enganche (20% del valor del inmueble):
          <span>${{ formatValue(financial.advanceAmount) }}</span>
        </p>
        <p>
          Monto a financiar con interés:
          <span
            >${{
              formatValue(financial.interestAmount + financial.financedAmount)
            }}</span
          >
        </p>
        <!-- <p>
          Interés ({{ interes }}%):
          <span>${{ formatValue(financial.interestAmount) }}</span>
        </p> -->
        <p>
          Pago en parcialidades:
          <span>${{ formatValue(financial.partialAmount) }}</span>
        </p>
        <!--  <p class="consulta">
          <span>*Consulta nuestras promociones de 12 meses sin intereses</span>
        </p> -->
      </div>
    </div>
    <!--  solo mostrar en desarrollos que cuenten con este plan (lomalta) -->
    <div v-if="activePlan == -1 || activePlan == -2" style="text-align:center">
      <a @click.prevent="sendCotizacion()" href="" class="btn btn__send"
        >Enviar información</a
      >
      <div class="line_horizontal"></div>
    </div>
    <!-- Plan Constructor / Plan Construye tu Casa: se muestran los cálculos (sin infografía) -->
    <div v-if="detallePlan" class="content__resume">
      <h2 class="content__resume-subtitle">{{ detallePlan.titulo }}</h2>
      <p v-for="linea in detallePlan.lineas" :key="linea.texto">
        {{ linea.texto }}
        <span v-if="linea.monto !== null">${{ formatValue(linea.monto) }}</span>
      </p>
      <p class="consulta"><span>{{ detallePlan.nota }}</span></p>
    </div>
   <!---->
    <div class="btn__box">
      <a
        :class="disabled"
        href=""
        @click.prevent="updateStepper"
        class="btn btn__back"
        >atras</a
      >
      <a
        v-if="resumeBox && planconstructor == 0"
        @click.prevent="_sendFinancial()"
        href=""
        class="btn btn__send"
        :style="sending ? 'pointer-events:none;opacity:.6' : ''"
        >{{ sending ? "enviando..." : "enviar" }}</a
      >
    </div>
  </div>
</template>
<script>
import RadioButtonQuote from "./RadioButtonQuote";
import LoaderResume from "./LoaderResume";
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";

// ---------------------------------------------------------------------------
// Grupos de financiamiento — Política de Ventas 2026
// Debe mantenerse sincronizado con SalesProjectInterestRange.java en scie-gtm-functions.
// ---------------------------------------------------------------------------

/** Plazos disponibles por grupo (meses). */
const PLAZOS_TERRENOS_GENERALES = [12, 24, 36, 48, 60];
const PLAZOS_CLUB_GOLF = [9, 24, 36];

/** Tasa de interés por grupo y plazo (Política de Ventas 2026).
 *  Usada solo para la etiqueta visual — el cálculo real lo hace el backend. */
const TASAS_PREVENTA = { 12: 0, 24: 10, 36: 12, 48: 14, 60: 14 };
const TASAS_ENTREGA_INMEDIATA = { 12: 6, 24: 10, 36: 12, 48: 14, 60: 14 };
/** Club de Golf: MH-Morelia (preventa) vs MH-Charo/Lotes con Acción (entrega inmediata),
 *  sin distinguir por etapa todavía — el cliente elige el esquema igual que en Valle Norte. */
const TASAS_CLUB_GOLF_PREVENTA = { 9: 0, 24: 10, 36: 12 };
const TASAS_CLUB_GOLF_ENTREGA_INMEDIATA = { 9: 6, 24: 10, 36: 12 };

const PREVENTA_IDS = new Set([47, 36, 33, 58, 55, 62]);
const ENTREGA_INMEDIATA_IDS = new Set([51, 56, 46, 45, 54, 61]);
// Proyecto real usado por /clubdegolf en el sitio (confirmado 2026-09-22 con la petición
// real de la web: GET /locations/availability/52 — no 9). Sin distinguir etapa por ahora.
const CLUB_GOLF_IDS = new Set([52]);

/** ProjectIds que habilitan Plan Constructor y Plan Construye tu Casa. Vacío por petición de
 *  Comercialización (2026-09-23); para reactivarlos: 45 Bosques, 58 Valle Norte, 61 Valle Sur. */
const PLAN_CONSTRUCTOR_IDS = new Set([]);

/** Desarrollos a los que aplica más de una política de venta: el cliente elige el esquema.
 *  Valle Norte = Subdivisión (preventa) + Habitacional (entrega inmediata) en el mismo proyecto de la BD.
 *  Se envía al backend como `salesScheme`. */
const ESQUEMAS_POR_PROJECT_ID = {
  58: [
    { id: "PREVENTA", texto: "Preventa" },
    { id: "ENTREGA_INMEDIATA", texto: "Entrega inmediata" },
  ],
  52: [
    { id: "PREVENTA", texto: "Preventa" },
    { id: "ENTREGA_INMEDIATA", texto: "Entrega inmediata" },
  ],
};

function getPlazosPorProjectId(projectId) {
  if (CLUB_GOLF_IDS.has(projectId)) return PLAZOS_CLUB_GOLF;
  return PLAZOS_TERRENOS_GENERALES;
}

function getTasaPorProjectId(projectId, meses, esquema) {
  if (CLUB_GOLF_IDS.has(projectId)) {
    return esquema === "ENTREGA_INMEDIATA"
      ? TASAS_CLUB_GOLF_ENTREGA_INMEDIATA[meses] ?? 0
      : TASAS_CLUB_GOLF_PREVENTA[meses] ?? 0;
  }
  if (esquema === "PREVENTA") return TASAS_PREVENTA[meses] ?? 0;
  if (esquema === "ENTREGA_INMEDIATA") return TASAS_ENTREGA_INMEDIATA[meses] ?? 0;
  if (PREVENTA_IDS.has(projectId)) return TASAS_PREVENTA[meses] ?? 0;
  if (ENTREGA_INMEDIATA_IDS.has(projectId)) return TASAS_ENTREGA_INMEDIATA[meses] ?? 0;
  return 0;
}

export default {
  name: "ResumeQuote",
  data() {
    return {
      activePlan: "12",
      esquemaActivo: "",
      interes: "9",
      name: "",
      lastName: "",
      email: "",
      cp: "",
      planconstructor: 0,
      telephone: "",
      desarrollo: "",
      stepper: 2,
      spin: false,
      resumeBox: false,
      sending: false,
      reset: 2,
      value: "I am the child.",
    };
  },
  props: ["user", "onResetQuote", "casasDeptos"],
  components: {
    RadioButtonQuote,
    LoaderResume,
  },
  computed: {
    ...mapGetters({
      selected: "getSelectedLocation",
      financial: "getSelectedStatusFinancial",
      loaderFinancial: "getStatusLoadingFinancial",
    }),
    disabled() {
      if (this.loaderFinancial) {
        return "btn__disabled";
      } else {
        return "";
      }
    },
    /** cveProyVta del proyecto de la ubicación seleccionada (lo agrega el store al armar cada ubicación) */
    projectId() {
      const id = Number(this.selected && this.selected.projectId);
      return Number.isFinite(id) && id > 0 ? id : null;
    },
    /** Plazos disponibles según el grupo del desarrollo */
    plazosDisponibles() {
      return getPlazosPorProjectId(this.projectId);
    },
    /** Esquemas de venta entre los que el cliente puede elegir (vacío o 1 = no se muestra selector) */
    esquemas() {
      return ESQUEMAS_POR_PROJECT_ID[this.projectId] || [];
    },
    /** Esquema a enviar al backend; null si el desarrollo tiene una sola política */
    esquemaParaEnviar() {
      return this.esquemas.length > 1 ? this.esquemaActivo : null;
    },
    /** Cálculo de Plan Constructor (-1) / Plan Construye tu Casa (-2) — Política de Ventas 2026 */
    detallePlan() {
      const precio = Number(this.selected && this.selected.value);
      if (!precio || (this.activePlan != -1 && this.activePlan != -2)) return null;
      const enganche = precio * 0.4;
      const restante = precio * 0.6;
      if (this.activePlan == -2) {
        return {
          titulo: "Plan construye tu casa",
          lineas: [
            { texto: "Precio total del terreno:", monto: precio },
            { texto: "Enganche (40%):", monto: enganche },
            { texto: "Plazo máximo para iniciar la construcción: 3 meses", monto: null },
            { texto: "A los 12 meses liquida el 60% restante:", monto: restante },
          ],
          nota: "*No se puede habitar la casa hasta liquidar el terreno. Sujeto a determinadas ubicaciones de cada desarrollo.",
        };
      }
      return {
        titulo: "Plan constructor",
        lineas: [
          { texto: "Precio total del terreno:", monto: precio },
          { texto: "Enganche mínimo (40%):", monto: enganche },
          { texto: "Plazo máximo para iniciar la construcción: 3 meses", monto: null },
          { texto: "A los 12 meses liquida el saldo restante (60%):", monto: restante },
          { texto: "Si no liquida a los 12 meses, el valor del terreno sube 10%; a los 24 meses liquida el saldo:", monto: precio * 1.1 - enganche },
          { texto: "Si no liquida a los 24 meses, sube otro 10%; límite de 30 meses, saldo final:", monto: precio * 1.2 - enganche },
        ],
        nota: "*No se puede habitar la casa hasta liquidar el terreno. Sujeto a determinadas ubicaciones de cada desarrollo.",
      };
    },
    /** true si el desarrollo habilita Plan Constructor / Plan Construye tu Casa */
    mostrarPlanesEspeciales() {
      return this.projectId !== null && PLAN_CONSTRUCTOR_IDS.has(this.projectId);
    },
  },
  methods: {
    ...mapActions(["getFinancial", "sendFinancial"]),
    /** Devuelve la tasa (%) para mostrar como etiqueta en el radio button */
    tasaParaPlazo(meses) {
      return getTasaPorProjectId(this.projectId, meses, this.esquemaParaEnviar);
    },
    /** El cliente cambió de esquema de venta: se recalcula el resumen si hay un plazo activo */
    updateEsquema(esquema) {
      this.esquemaActivo = esquema;
      if (this.activePlan > 0) {
        this._getFinancial();
      }
    },
    async _getFinancial() {
      this.resumeBox = false;
      try {
        let financialData = {
          locationId: this.selected.id,
          months: this.activePlan,
        };
        if (this.esquemaParaEnviar) financialData.salesScheme = this.esquemaParaEnviar;
        await this.getFinancial(financialData);
      } catch (e) {
        Swal.fire({
            icon: "error",
            title: "Ha ocurrido un error, intente mas tarde",
            confirmButtonColor: "#822013",
            allowOutsideClick: false,
            confirmButtonText: "OK",
            showClass: {
                popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
            }
        }).then(() => {
            this.onResetQuote()
        })
      } finally {
        this.resumeBox = true;
      }
    },
    // El aviso de éxito solo se muestra cuando la Lambda confirmó el envío del correo.
    async mostrarEnvioExitoso(texto) {
      await Swal.fire({
        icon: "success",
        title: "Mensaje enviado correctamante",
        text: texto,
        confirmButtonColor: "#14274a",
        allowOutsideClick: false,
        confirmButtonText: "OK",
        showClass: { popup: "animate__animated animate__fadeInDown" },
        hideClass: { popup: "animate__animated animate__fadeOutUp" },
      });
      this.onResetQuote();
    },
    async mostrarErrorEnvio() {
      await Swal.fire({
        icon: "error",
        title: "Ha ocurrido un error, intente mas tarde",
        confirmButtonColor: "#822013",
        allowOutsideClick: false,
        confirmButtonText: "OK",
        showClass: { popup: "animate__animated animate__fadeInDown" },
        hideClass: { popup: "animate__animated animate__fadeOutUp" },
      });
      this.onResetQuote();
    },
    async _sendFinancial() {
      if (this.sending) return;
      this.sending = true;
      try {
        await this.sendFinancial({
          locationId: this.selected.id,
          email: this.email,
          customerName: `${this.name} ${this.lastName}`,
          firstName: this.name,
          lastName: this.lastName,
          months: this.activePlan,
          city: this.cp,
          phone: this.telephone,
          ...(this.esquemaParaEnviar ? { salesScheme: this.esquemaParaEnviar } : {}),
        });
        await this.mostrarEnvioExitoso(
          "La cotizacion te la enviaremos en breve al correo electronico que proporcionaste en el paso anterior."
        );
      } catch (e) {
        await this.mostrarErrorEnvio();
      } finally {
        this.sending = false;
      }
    },
    formatValue(value) {
      let val = (value / 1).toFixed(2).replace(",", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    updateActivePlan(plan, interes) {
      this.activePlan = plan;
      this.interes = interes;
      this.planC();
    },
    planC() {
      if (this.activePlan == -1) {
        this.planconstructor = 1;
      } else if (this.activePlan == -2) {
        this.planconstructor = 2;
      } else {
        this.planconstructor = 0;
        this._getFinancial();
      }
    },
    updateStepper() {
      this.$emit("onUpdateStepper", (this.stepper -= 1));
    },
    userElements(element) {
      this.name = element.name;
      this.lastName = element.lastName;
      this.email = element.email;
      this.cp = element.cp;
      this.telephone = element.telephone;
      this.desarrollo = element.desarrollo;
    },
    async sendCotizacion() {
      if (this.sending) return;
      this.sending = true;
      try {
        await this.sendFinancial({
          locationId: this.selected.id,
          email: this.email,
          customerName: `${this.name} ${this.lastName}`,
          firstName: this.name,
          lastName: this.lastName,
          months: this.activePlan,
          city: this.cp,
          phone: this.telephone
        });
        await this.mostrarEnvioExitoso(
          "la cotizacion te la enviaremos al correo electronico que proporcionaste en el paso anterior."
        );
      } catch (e) {
        await this.mostrarErrorEnvio();
      } finally {
        this.sending = false;
      }
    },
  },
  mounted() {
    this.user.forEach(this.userElements);
    // Establecer el plan activo inicial al primer plazo disponible para este desarrollo
    if (this.plazosDisponibles.length > 0) {
      this.activePlan = String(this.plazosDisponibles[0]);
    }
    if (this.esquemas.length > 0) {
      this.esquemaActivo = this.esquemas[0].id;
    }
  },
};
</script>
<style scoped>
.hider {
  display: none !important;
}
</style>